import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

import TAU1 from '../../assets/images/DCP-Logo-Light.png';
import TAU2 from '../../assets/images/logo-newsbtc.png';
import TAU3 from '../../assets/images/cryptomode.png';
import TAU4 from '../../assets/images/CE-Final.png';
import TAU5 from '../../assets/images/thecryptobsc.png';
import './talkedabout.css';
import AnimatedText from 'react-animated-text-content';

const TalkedAboutUs = () => {
  return (
    <Container fluid className='np nm tau__main__container'>
      <Container className='tau__container'>
        <Row>
          <Col>
            <h1 className='tau__h1 animate__animated animate__bounce animate__faster'>
              <AnimatedText
                type='chars' // animate words or chars
                animation={{
                  x: '200px',
                  y: '-30px',
                  scale: 1.1,
                  ease: 'ease-in-out',
                }}
                animationType='throw'
                interval={0.06}
                duration={1}
                tag='p'
                className='animated-paragraph'
                includeWhiteSpaces
                threshold={0.1}
                rootMargin='20%'
              >
                Talked About Us
              </AnimatedText>
            </h1>
          </Col>
        </Row>{' '}
        <Row className='img__col__row'>
          <Col className='tau__col' sm={12} md={3}>
            <a
              href='https://www.dailycryptopost.com/'
              rel='noreferrer'
              target='_blank'
            >
              <img src={TAU1} alt='' width='80%' />
            </a>
          </Col>
          <Col className='tau__col' sm={12} md={3}>
            <a href='https://www.newsbtc.com/' rel='noreferrer' target='_blank'>
              <img src={TAU2} alt='' width='80%' />
            </a>
          </Col>
          <Col className='tau__col' sm={12} md={3}>
            <a href='https://cryptomode.com/' rel='noreferrer' target='_blank'>
              <img src={TAU3} alt='' width='30%' />
            </a>
          </Col>
          <Col className='tau__col' sm={12} md={3}>
            <a href='https://coinedition.com/' rel='noreferrer' target='_blank'>
              <img src={TAU4} alt='' width='60%' />
            </a>
          </Col>
          <Col className='tau__col' sm={12} md={3}>
            <a
              href='https://thecryptobasic.com/'
              rel='noreferrer'
              target='_blank'
            >
              <img src={TAU5} alt='' width='100%' />
            </a>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default TalkedAboutUs;
